<template>
  <d-card :class="['stats-small', computedVariationClass, 'card', 'card-small']" class="dash-card">
    <d-card-body :class="[computedBodyClass]">
      <div :class="['d-flex', computedInnerWrapperClass]">
        <div :class="['stats-small__data', computedDataFieldClass]">
          <span
            :class="[
              'stats-small__label',
              'text-uppercase',
              computedLabelClass
            ]"
            v-tooltip="{
              content: explanation,
              placement: 'top-center',
              offset: 0,
              
            }"
          >{{ label }}</span>

          <h6 :class="['stats-small__value', 'count', computedValueClass]">{{ value }}</h6>
        </div>
      </div>
      <!--<canvas
        :height="computedCanvasHeight"
        ref="canvas"
        :class="[computedChartId]"
      ></canvas>-->
    </d-card-body>
  </d-card>
</template>

<script>
import Chart from "../../utils/chart";
import { nanoid } from "../../utils";

export default {
  name: "d-small-stats",
  props: {
    /**
     * The element ID.
     */
    id: {
      type: String,
      required: true
    },
    /**
     * The label.
     */
    label: {
      type: String,
      default: "Label"
    },
    explanation: {
      type: String,
      default: "Label"
    },
    /**
     * The value.
     */
    value: {
      type: [Number, String],
      default: 0
    },
    /**
     * The percentage number or string.
     */
    percentage: {
      type: [Number, String],
      default: 0
    },
    /**
     * Whether is a value increase.
     */
    increase: {
      type: Boolean,
      default: true
    },
    /**
     * Whether is a value decrease.
     */
    decrease: {
      type: Boolean,
      default: false
    },
    /**
     * The Chart.js options.
     */
    chartOptions: {
      type: Object,
      default() {
        return {};
      }
    },
    /**
     * The chart dataset.
     */
    chartData: {
      type: Array,
      required: true,
      default() {
        return [];
      }
    },
    /**
     * The chart configuration. This may override every other setting.
     */
    chartConfig: {
      type: Object
    },
    /**
     * The variation.
     */
    variation: {
      type: String,
      default: null
    }
  },
  computed: {
    computedChartId() {
      return this.id || `stats-small-${nanoid()}`;
    },
    computedPercentageModifier() {
      return this.increase ? "increase" : "decrease";
    },
    computedVariationClass() {
      return this.variation ? `stats-small--${this.variation}` : null;
    },
    computedBodyClass() {
      if (this.variation === "1") {
        return "p-0 d-flex";
      }

      return "px-0 pb-0";
    },
    computedInnerWrapperClass() {
      if (this.variation === "1") {
        return "flex-column m-auto";
      }

      return "px-3";
    },
    computedDataFieldClass() {
      if (this.variation === "1") {
        return "text-center";
      }

      return null;
    },
    computedLabelClass() {
      if (this.variation === "1") {
        return null;
      }

      return "mb-1";
    },
    computedValueClass() {
      if (this.variation === "1") {
        return "my-3";
      }

      return "m-0";
    },
    computedInnerDataFieldClass() {
      if (this.variation === "1") {
        return null;
      }

      return "text-right align-items-center";
    },
    computedCanvasHeight() {
      if (this.variation === "1") {
        return 120;
      }

      return 60;
    }
  },
  mounted() {
    const chartOptions = {
      ...{
        maintainAspectRatio: true,
        responsive: true,
        legend: {
          display: false
        },
        tooltips: {
          enabled: false,
          custom: false
        },
        elements: {
          point: {
            radius: 0
          },
          line: {
            tension: 0.33
          }
        },
        scales: {
          xAxes: [
            {
              gridLines: false,
              ticks: {
                display: false
              }
            }
          ],
          yAxes: [
            {
              gridLines: false,
              scaleLabel: false,
              ticks: {
                display: false,
                isplay: false,
                // Avoid getting the graph line cut of at the top of the canvas.
                // Chart.js bug link: https://github.com/chartjs/Chart.js/issues/4790
                suggestedMax: Math.max(...this.chartData[0].data) + 1
              }
            }
          ]
        }
      },
      ...this.chartOptions
    };

    const chartConfig = {
      ...{
        type: "line",
        data: {
          ...{
            labels: ["Label 1", "Label 2", "Label 3", "Label 4", "Label 5"]
          },
          ...{
            datasets: this.chartData
          }
        },
        options: chartOptions
      },
      ...this.chartConfig
    };

    new Chart(this.$refs.canvas, chartConfig);
  }
};
</script>
<style lang="scss">
.dash-card {
  background: #fff;
  box-shadow: 0 2px 0 rgba(90, 97, 105, 0.11), 0 4px 8px rgba(90, 97, 105, 0.12),
    0 10px 10px rgba(90, 97, 105, 0.06), 0 7px 70px rgba(90, 97, 105, 0.1) !important;
}

.stats-small--1 .stats-small__label {
  color: #212143;
  opacity: 0.7;
  border-bottom: 1px dotted #2121438c;
}
.stats-small--1 .stats-small__value {
  color: #212143;
}
.stats-small--1 canvas {
  opacity: 0.9;
  border-radius: 5px;
}
.input-group-sm .vdp-datepicker input {
  height: 1.9375rem;
  font-size: 0.875rem;
  line-height: 1.5;
  background: #f2557a;
  color: white;
  font-weight: 700;
  border-radius: 5px !important;
  border: 2px solid #242447;
}
.input-group-text {
  max-height: 27px;
  background: #f05479;
  border-radius: 5px;
  border: 0px;
  color: #212143;
}
.input-group-append {
  display: none;
  margin-left: 3px;
  margin-top: 1.5px;
}
.tooltip {
  display: block !important;
  z-index: 10000;

  .tooltip-inner {
    background: #232349;
    color: white;
    font-weight: 500;
    border-radius: 5px;
    padding: 10px 10px 10px;
  }

  .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: #232349;
    z-index: 1;
  }

  &[x-placement^="top"] {
    margin-bottom: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 0 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      bottom: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="bottom"] {
    margin-top: 5px;

    .tooltip-arrow {
      border-width: 0 5px 5px 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-top-color: transparent !important;
      top: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="right"] {
    margin-left: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 5px 0;
      border-left-color: transparent !important;
      border-top-color: transparent !important;
      border-bottom-color: transparent !important;
      left: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[x-placement^="left"] {
    margin-right: 5px;

    .tooltip-arrow {
      border-width: 5px 0 5px 5px;
      border-top-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      right: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[aria-hidden="true"] {
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.15s, visibility 0.15s;
  }

  &[aria-hidden="false"] {
    visibility: visible;
    opacity: 1;
    transition: opacity 0.15s;
  }
}
</style>
